import React from 'react';

export default function FaqPage() {
  return (
    <main className="faq-page">
      {/* Convert all content from frequently-asked-questions.html here as JSX */}
      <header className="page-header">
        <div className="text-info">
          <h1>Frequently Asked Questions</h1>
          <p>FAQ content goes here.</p>
        </div>
        <div className="img">
          <img src="/static/media/faq-header-image.webp" alt="FAQ" />
        </div>
      </header>
      {/* ...more sections... */}
      <footer className="footer">
        <div className="copyright">
          <p>Copyright © 2022 Safenet Banking. Licensed by the Central Bank of United States.</p>
        </div>
      </footer>
    </main>
  );
}
